"use client"
import type { ButtonHTMLAttributes } from "react"
import "./config-switch.css"

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> & {
  checked?: boolean
  onChange?: (checked: boolean) => void
  size?: "small" | "default"
}

export function ConfigSwitch({checked=false, onChange, size: _size, className="", ...props}: Props) {
  return <button {...props} type="button" role="switch" aria-checked={checked}
    className={`swan-switch ${className}`} onClick={()=>onChange?.(!checked)}>
    <span className="swan-track" aria-hidden="true">
      <span className="swan-thumb">{checked ? "✔️" : "✖️"}</span>
    </span>
  </button>
}
